export type Primitive = string | number | bigint | boolean | symbol | null | undefined;

export enum RequestStatuses {
    pending = 'pending',
    fulfilled = 'fulfilled',
    rejected = 'rejected'
}

export enum CookieNames {
    accessToken = 'access_token',
    refreshToken = 'refresh_token'
}
